import { CSSProperties, FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Popconfirm, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import asyncErrorHandler from 'utils/asyncErrorHandler';
import timeTracking from 'services/timeTracking';
import { setGlobalLogTrigger } from 'store/container/globalLog/globalLog-slice';

interface DeleteTimerProps {
  uuid: any;
  // eslint-disable-next-line react/no-unused-prop-types
  modelType?: 'task' | 'request';
  style?: CSSProperties;
  onDelete?: any;
}

const DeleteTimer: FC<DeleteTimerProps> = ({ uuid, style, onDelete }) => {
  const [deleting, setDeleting] = useState(false);

  const dispatch = useDispatch();

  const onDeleteHandler = async () => {
    setDeleting(true);

    try {
      await timeTracking.deleteEntry(uuid);

      dispatch(setGlobalLogTrigger());

      if (onDelete) {
        onDelete();
      }
    } catch (error) {
      asyncErrorHandler(error);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Popconfirm onConfirm={onDeleteHandler} title="Do you want to delete this timelog?">
      <Tooltip title="Delete">
        <Button type="link" size="small" style={style} icon={<DeleteOutlined />} loading={deleting} />
      </Tooltip>
    </Popconfirm>
  );
};

export default DeleteTimer;
